// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_burgerMenu__TPMaS {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.styles_wrapper__CctjK {
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
}

.styles_contentWrapper__uSBfP {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.styles_btnWrapper__JxF6B {
  width: 100%;
  height: 46px;
}

.styles_buttonsBlock__dU\\+-S {
  position: relative;
  height: 100%;
  min-height: 46px;
  width: 100%;
  display: flex;
  gap: 8px;
  overflow: hidden;
}

.styles_payment__neHfX {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
@media (max-width: 576px) {
  .styles_payment__neHfX {
    top: unset;
    bottom: 0;
    transform: translate(-50%, 0);
    height: 80vh;
    overflow-y: scroll;
  }
  .styles_payment__neHfX iframe {
    width: 100vh !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pageWrapper/pageHeaderMobile/burgerMenu/styles.module.scss","webpack://./src/assets/styles/mixin/breakpoints.scss"],"names":[],"mappings":"AAGA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAFF;;AAKA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,MAAA;AAFF;;AAKA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;AAFF;;AAKA;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EAEA,aAAA;EACA,QAAA;EACA,gBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAHF;ACLE;EDIF;IAOI,UAAA;IACA,SAAA;IACA,6BAAA;IAEA,YAAA;IACA,kBAAA;EAHF;EAKE;IACE,uBAAA;EAHJ;AACF","sourcesContent":["@import './src/assets/styles/variables/colors';\n@import './src/assets/styles/mixin/breakpoints';\n\n.burgerMenu {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.wrapper {\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0;\n}\n\n.contentWrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.btnWrapper {\n  width: 100%;\n  height: 46px;\n}\n\n.buttonsBlock {\n  position: relative;\n  height: 100%;\n  min-height: 46px;\n  width: 100%;\n\n  display: flex;\n  gap: 8px;\n  overflow: hidden;\n}\n\n.payment {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n\n  @include sm {\n    top: unset;\n    bottom: 0;\n    transform: translate(-50%, 0);\n\n    height: 80vh;\n    overflow-y: scroll;\n\n    iframe {\n      width: 100vh !important;\n    }\n  }\n}\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"burgerMenu": `styles_burgerMenu__TPMaS`,
	"wrapper": `styles_wrapper__CctjK`,
	"contentWrapper": `styles_contentWrapper__uSBfP`,
	"btnWrapper": `styles_btnWrapper__JxF6B`,
	"buttonsBlock": `styles_buttonsBlock__dU+-S`,
	"payment": `styles_payment__neHfX`
};
export default ___CSS_LOADER_EXPORT___;
